import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';
import {ScheduleAudience} from '@domain/activity/schedule/schedule.dto';
import {ActivityDTO, ActivityType} from '@domain/activity/activity.dto';

@Pipe({
  name: 'scheduleLevel',
  pure: true
})
export class ScheduleLevelPipe implements PipeTransform {

  private readonly transloco = inject(TranslocoService);

  public transform(audience: ScheduleAudience | null): string | null {
    return this.format(audience);
  }

  public format(audience: ScheduleAudience | null, activity: ActivityDTO | null = null): string | null {
    if (activity?.type === ActivityType.Event) {
      return null;
    }
    const level = audience?.level;
    if (!level) {
      return null;
    }
    return this.transloco.translate(`activity.item.level.${level}`).toLowerCase();
  }

}
